import events from '@/hooks/events';
import actions from '../constants';

export default {
  useShowAutoApproval: () => events.useSimpleDispatch(actions.SHOW_AUTO_APPROVAL_CONFIGURATION),
};
